import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent } from '../ui/card';
import { AlertTriangle } from 'lucide-react';

function SuperadminChurnWarningTile() {
  const [data, setData] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const fetchChurnWarnings = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/superadmin-stats/hr-churn-warning`, {
          withCredentials: true,
        });
        setData(res.data);
      } catch (err) {
        console.error('Fehler beim Laden der Churn-Warnungen:', err);
      }
    };

    fetchChurnWarnings();
  }, []);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Card className="h-full">
      <CardContent className="p-6 space-y-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <AlertTriangle size={28} className="text-red-500" />
            <div>
              <p className="text-sm text-gray-400">Churn-Warnung</p>
              <p className="text-xl font-bold">
                {data.length > 0 ? `${data.length} HR-Accounts auffällig` : 'Keine Warnungen'}
              </p>
            </div>
          </div>
          {data.length > 0 && (
            <span
              onClick={handleToggle}
              className="text-sm text-blue-400 underline cursor-pointer"
            >
              {expanded ? 'Schließen' : 'Anzeigen'}
            </span>
          )}
        </div>

        {expanded && (
          <ul className="mt-2 text-sm text-gray-300 list-disc list-inside">
            {data.map((row, index) => (
              <li key={index}>
                {row.company} (Kunden-ID {row.customerId}) – {row.inactiveHR} inaktive HR-User
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}

export default SuperadminChurnWarningTile;
